import React from 'react';
import { Text, View } from 'react-native';
import styles from './styles';

interface IProgressBar {
  percentage: number;
}

const ProgressBar: React.FC<IProgressBar> = ({ percentage }) => {
  return (
    <View style={styles.progressBarContainer}>
      <Text style={styles.progressBarTitle}>
        Seu progresso na leitura:
      </Text>
      <View style={styles.progressBar}>
        <View style={[
          styles.currentProgress,
          {
            width: `${percentage}%`
          }
        ]}/>
        <Text style={[
          styles.currentProgressText,
          {
            marginLeft: `${percentage < 80 ? percentage - 5 : 70}%`,
            display: percentage == 100 ? "none" : "flex"
          }
        ]}>
          {`${percentage}%`}
        </Text>
      </View>

      <Text style={styles.fullProgressText}>100%</Text>
    </View>
  );
};

export default ProgressBar;